/** @format */

import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NavController } from '@ionic/angular';
import { map } from 'rxjs/operators';
import { DbService } from 'src/services/db.service';

@Component({
  selector: 'app-realtime-pop',
  templateUrl: './realtime-pop.component.html',
  styleUrls: ['./realtime-pop.component.scss'],
})
export class RealtimePopComponent implements OnInit {
  // test 가짜 데이터
  // totalRequst = 1304;
  // startCard = [
  //   { from: '전라북도 유성구', to: '전락북도 유성구', movingDate: '2020년 3월 15일', moveType: '가정' },
  //   { from: '전라북도 유성구', to: '전락북도 유성구', movingDate: '2020년 3월 15일', moveType: '소형' },
  //   { from: '전라북도 유성구', to: '전락북도 유성구', movingDate: '2020년 3월 15일', moveType: '사무실' },
  // ];

  public startCard$;
  // totalRequset = 1304;
  nodatas;
  constructor(
    public dialogRef: MatDialogRef<RealtimePopComponent>,
    public navc: NavController,
    public db: DbService // @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.startCard$ = this.db
      .collection$('order', ref => ref.where('endOrder', '==', false).where('type', '==', 'movie').orderBy('dateCreated', 'desc'))
      .pipe(
        map(datas => {
          datas.forEach(data => {
            //// 연결된 업체수가 지원정원을 넘었을 경우 처리 ///////
            const connectCompanys = data.connectCompanys ? data.connectCompanys.length : 0;
            if (data.estimateCount <= connectCompanys) {
              data.endOrder = true;
              this.db.updateAt(`order/${data.id}`, { endOrder: true });
            }
          });
          const newDatas = datas.filter(data => data.dateMoved || data.endOrder === false);
          if (newDatas.length < 1) {
            this.nodatas = true;
          } else {
            this.nodatas = false;
          }
          return newDatas.map(data => {
            const category = data.category;
            data.category = category.replace('이사', '');
            return data;
          });
        })
      );
  }

  ngOnInit() {}

  //팝업 닫기
  closePop(): void {
    this.dialogRef.close();
  }

  //페이지 이동
  goDetail() {
    // this.navc.navigateForward([])
  }

  gotoOrder(order) {
    this.dialogRef.close();
    this.navc.navigateForward(['/video-order'], {
      queryParams: {
        orderId: order.id,
      },
    });
  }
}
